(function () {
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  function formatPrice(price) {
    return parseFloat(price).toFixed(2).replace('.', ',');
  }

  // Shopify serves the original (often multi-MB) upload unless a size is
  // requested — that's the real cause of "loading between articles" lag,
  // not network round-trips, since the whole queue is already fetched
  // upfront. Asking for a size that actually fits the card cuts per-card
  // load time drastically.
  function getImageUrl(entry) {
    const raw = entry && entry.product.images && entry.product.images[0] ? entry.product.images[0].src : '';
    if (!raw) return '';
    return raw.includes('?') ? `${raw}&width=800` : `${raw}?width=800`;
  }

  // Warms the browser's image cache for upcoming cards so swiping past the
  // current one feels instant instead of waiting on a fresh download.
  function preloadImage(entry) {
    const url = getImageUrl(entry);
    if (!url) return;
    const img = new Image();
    img.src = url;
  }

  const CATEGORY_LABELS = {
    'vintage-jeans': 'Jeans',
    'pullover-sweater': 'Pullover & Sweater',
    'vintage-jacken-mantel': 'Jacken & Mäntel',
    'vintage-accessoires-1': 'Accessoires',
    'alle-artikel': 'Alle Artikel',
  };

  // These are one-off vintage pieces: each product has a single variant
  // whose "option" is just the garment's measurements, not a real size.
  // The size instead lives at the end of the product title, e.g.
  // "Vintage Levi's Baggy Jeans „501“ (M)" — match against that instead.
  function getProductSize(title) {
    const match = title.match(/\(([A-Za-z0-9]{1,4})\)\s*$/);
    return match ? match[1].toUpperCase() : null;
  }

  function findMatchingVariant(product, size) {
    if (getProductSize(product.title) !== size.toUpperCase()) return null;
    const variant = (product.variants || [])[0];
    if (!variant || !variant.available) return null;
    return variant;
  }

  // Mirrors collection-quick-add.js's silent cart-drawer update so a swipe
  // "like" feels consistent with the rest of the site's quick-add — the
  // drawer content refreshes in the background without popping open.
  function updateCartSectionsSilently(parsedState) {
    if (!parsedState.sections) return;

    const cartDrawerRoot = document.getElementById('CartDrawer');
    if (cartDrawerRoot && parsedState.sections['cart-drawer']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-drawer'], 'text/html')
        .querySelector('#CartDrawer');
      if (parsed) cartDrawerRoot.innerHTML = parsed.innerHTML;
    }

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections['cart-icon-bubble']) {
      const parsed = new DOMParser()
        .parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html')
        .querySelector('.shopify-section');
      if (parsed) cartIconBubble.innerHTML = parsed.innerHTML;
    }

    const cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      cartDrawerEl.classList.remove('is-empty');
      const inner = cartDrawerEl.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
  }

  function showAddedToCartToast() {
    const existing = document.getElementById('OnhowAddedToast');
    if (existing) existing.remove();
    clearTimeout(window.__onhowToastTimeout);

    const cartIcon = document.querySelector('#cart-icon-bubble');
    const toast = document.createElement('div');
    toast.id = 'OnhowAddedToast';
    toast.className = 'onhow-added-toast';
    toast.innerHTML =
      '<span class="onhow-added-toast__icon" aria-hidden="true">&#10003;</span>' +
      '<span class="onhow-added-toast__text">Erfolgreich in den <a href="/cart" class="onhow-added-toast__link">Warenkorb</a> hinzugef&uuml;gt</span>';
    document.body.appendChild(toast);

    if (cartIcon) {
      const rect = cartIcon.getBoundingClientRect();
      toast.style.top = `${Math.round(rect.bottom + 10)}px`;
      toast.style.right = `${Math.round(window.innerWidth - rect.right)}px`;
    }

    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.__onhowToastTimeout = setTimeout(() => {
      toast.classList.remove('is-visible');
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  function pulseCartIcon() {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.classList.remove('onhow-cart-pulse');
    // eslint-disable-next-line no-void
    void cartIcon.offsetWidth;
    cartIcon.classList.add('onhow-cart-pulse');
    setTimeout(() => cartIcon.classList.remove('onhow-cart-pulse'), 400);
  }

  async function addToCart(variantId) {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartDrawer && cartDrawer.getSectionsToRender) {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const json = await res.json();
      if (json.status) return;

      updateCartSectionsSilently(json);
      showAddedToCartToast();
      pulseCartIcon();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'swipe-discovery', cartData: json });
      }
    } catch (error) {
      console.error(error);
    }
  }

  function init() {
    const fab = document.getElementById('SwipeDiscoveryFab');
    const panel = document.getElementById('SwipeDiscoveryPanel');
    if (!fab || !panel) return;

    const closeBtn = panel.querySelector('.swipe-discovery-panel__close');
    const filtersLink = document.getElementById('SwipeDiscoveryFiltersLink');
    const filterStep = panel.querySelector('[data-step="filters"]');
    const cardsStep = panel.querySelector('[data-step="cards"]');
    const startBtn = panel.querySelector('.swipe-discovery-start');
    const stack = document.getElementById('SwipeDiscoveryStack');
    const skipBtn = document.getElementById('SwipeDiscoverySkip');
    const likeBtn = document.getElementById('SwipeDiscoveryLike');

    let selectedSize = null;
    let selectedGender = null;
    let selectedCategory = null;
    let queue = [];
    let currentEntry = null;
    let liveCard = null;
    let dragging = false;
    let dragStartX = 0;
    let dragDeltaX = 0;

    function updateStartButton() {
      const ready = Boolean(selectedSize && selectedGender && selectedCategory);
      startBtn.disabled = !ready;
      startBtn.textContent = ready ? 'Los geht’s →' : 'Bitte Größe, Geschlecht & Kategorie wählen';
    }

    panel.querySelectorAll('[data-pill-group]').forEach((group) => {
      const groupName = group.dataset.pillGroup;
      group.querySelectorAll('.swipe-discovery-pill').forEach((pill) => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('.swipe-discovery-pill').forEach((p) => p.classList.remove('is-selected'));
          pill.classList.add('is-selected');
          if (groupName === 'size') selectedSize = pill.dataset.value;
          else if (groupName === 'gender') selectedGender = pill.dataset.value;
          else selectedCategory = pill.dataset.value;
          updateStartButton();
        });
      });
    });

    function openPanel() {
      panel.hidden = false;
      document.body.classList.add('swipe-discovery-open');
    }

    function closePanel() {
      panel.hidden = true;
      document.body.classList.remove('swipe-discovery-open');
    }

    fab.addEventListener('click', openPanel);
    closeBtn.addEventListener('click', closePanel);

    function resetToFilters() {
      cardsStep.hidden = true;
      filterStep.hidden = false;
      filtersLink.hidden = true;
    }

    filtersLink.addEventListener('click', resetToFilters);

    async function loadQueue() {
      stack.innerHTML = '<p class="swipe-discovery-loading">Passende Teile werden geladen&hellip;</p>';
      try {
        const res = await fetch(`/collections/${selectedCategory}/products.json?limit=100`);
        const data = await res.json();
        const products = data.products || [];
        const matches = [];
        products.forEach((product) => {
          if (!(product.tags || []).includes(selectedGender)) return;
          const variant = findMatchingVariant(product, selectedSize);
          if (variant) matches.push({ product, variant });
        });
        queue = shuffle(matches);
      } catch (error) {
        console.error(error);
        queue = [];
      }
    }

    function showEmptyState() {
      liveCard = null;
      stack.innerHTML =
        '<div class="swipe-discovery-empty">' +
        '<p>Keine passenden Artikel in dieser Kombination gefunden.</p>' +
        '<p>Versuch es mit einer anderen Gr&ouml;&szlig;e, Geschlecht oder Kategorie.</p>' +
        '<button type="button" class="swipe-discovery-restart">Zur&uuml;ck zur Auswahl</button>' +
        '</div>';
      stack.querySelector('.swipe-discovery-restart').addEventListener('click', resetToFilters);
    }

    function showEndState() {
      stack.innerHTML =
        '<div class="swipe-discovery-end">' +
        '<p>Das war’s erstmal! 🎉</p>' +
        '<p>Schau sp&auml;ter wieder vorbei f&uuml;r neue Teile.</p>' +
        '<button type="button" class="swipe-discovery-restart">Nochmal von vorne</button>' +
        '</div>';
      stack.querySelector('.swipe-discovery-restart').addEventListener('click', resetToFilters);
    }

    function renderNextCard() {
      if (queue.length === 0) {
        showEndState();
        liveCard = null;
        return;
      }
      currentEntry = queue.shift();

      // Clear any leftover non-card content (the initial loading message, or
      // a previous empty/end state) without touching a still-animating
      // "leaving" card from the swipe that just happened — that one removes
      // itself on its own timeout once its fling-out animation finishes.
      Array.from(stack.children).forEach((child) => {
        if (!child.classList.contains('swipe-discovery-card')) child.remove();
      });

      const image = getImageUrl(currentEntry);

      const categoryLabel = CATEGORY_LABELS[selectedCategory] || '';
      const vendorBadge = currentEntry.product.vendor
        ? `<span class="swipe-discovery-card__vendor-badge">${currentEntry.product.vendor}</span>`
        : '';
      const categoryLine = categoryLabel
        ? `<span class="swipe-discovery-card__category">${categoryLabel}</span>`
        : '';

      const card = document.createElement('div');
      card.className = 'swipe-discovery-card';
      card.style.zIndex = '1';
      card.style.backgroundImage = `url('${image}')`;
      card.innerHTML =
        vendorBadge +
        '<div class="swipe-discovery-card__overlay">' +
        categoryLine +
        `<h3 class="swipe-discovery-card__title">${currentEntry.product.title}</h3>` +
        `<span class="swipe-discovery-card__price">&euro;${formatPrice(currentEntry.variant.price)}</span>` +
        '</div>';
      stack.appendChild(card);
      liveCard = card;

      preloadImage(queue[0]);
      preloadImage(queue[1]);
    }

    function flingCard(card, direction) {
      if (!card) return;
      card.style.transition = 'transform 0.3s ease, opacity 0.3s ease';
      card.style.transform = `translateX(${direction * 600}px) rotate(${direction * 20}deg)`;
      card.style.opacity = '0';
    }

    // Advances to the next card immediately (no artificial delay) — the
    // just-swiped card keeps flying off on its own as a detached, non-
    // interactive element while the new one becomes live right away. The
    // previous version waited 280ms before unlocking the next card, which
    // silently swallowed any swipe attempted during that window (currentEntry
    // was already null) — that dead window was the "hakt" bug where quick
    // successive swipes needed 3-4 tries to register.
    function advance(direction) {
      const leaving = liveCard;
      liveCard = null;
      currentEntry = null;

      if (leaving) {
        leaving.style.pointerEvents = 'none';
        leaving.style.zIndex = '2';
        flingCard(leaving, direction);
        setTimeout(() => leaving.remove(), 320);
      }

      renderNextCard();
    }

    function handleLike() {
      if (!currentEntry) return;
      addToCart(currentEntry.variant.id);
      advance(1);
    }

    function handleSkip() {
      if (!currentEntry) return;
      advance(-1);
    }

    likeBtn.addEventListener('click', handleLike);
    skipBtn.addEventListener('click', handleSkip);

    // Drag-to-swipe via delegated pointer events on the stack container —
    // tracks the live card directly (liveCard) rather than re-querying
    // ".swipe-discovery-card", since a still-animating "leaving" card can
    // briefly coexist with the new live one after a swipe.
    let moveWatchdogId = null;

    function clearMoveWatchdog() {
      if (moveWatchdogId) {
        clearTimeout(moveWatchdogId);
        moveWatchdogId = null;
      }
    }

    // The Shopify theme-preview toolbar is an iframe overlapping the bottom
    // of the screen — a separate document. If the mouse is released while
    // the cursor is over it, the browser hands that native mouseup to the
    // IFRAME's event system instead of ours, purely based on screen-position
    // hit-testing, before any JS ever runs. No listener in our page — not
    // pointerup, not pointercancel, not even lostpointercapture — can be
    // notified of an event that was never delivered to our document at all,
    // which is exactly what left dragging stuck true forever with the card
    // frozen wherever the last pointermove left it. This watchdog sidesteps
    // that entirely: if movement goes quiet for a bit while still marked as
    // dragging, treat the gesture as over and resolve it from the last known
    // position, regardless of whether a release event ever arrives.
    function armMoveWatchdog() {
      clearMoveWatchdog();
      moveWatchdogId = setTimeout(endDrag, 400);
    }

    stack.addEventListener('pointerdown', (event) => {
      const card = event.target.closest('.swipe-discovery-card');
      if (!card || card !== liveCard) return;
      dragging = true;
      dragStartX = event.clientX;
      dragDeltaX = 0;
      card.style.transition = 'none';
      card.setPointerCapture(event.pointerId);
      armMoveWatchdog();
    });

    stack.addEventListener('pointermove', (event) => {
      if (!dragging || !liveCard) return;
      dragDeltaX = event.clientX - dragStartX;
      liveCard.style.transform = `translateX(${dragDeltaX}px) rotate(${dragDeltaX / 20}deg)`;
      armMoveWatchdog();
    });

    function endDrag() {
      clearMoveWatchdog();
      if (!dragging) return;
      dragging = false;
      const card = liveCard;
      if (!card) return;
      card.style.transition = 'transform 0.3s ease';

      if (dragDeltaX > 100) {
        handleLike();
      } else if (dragDeltaX < -100) {
        handleSkip();
      } else {
        card.style.transform = '';
      }
      dragDeltaX = 0;
    }

    stack.addEventListener('pointerup', endDrag);
    stack.addEventListener('pointercancel', endDrag);
    stack.addEventListener('lostpointercapture', endDrag);

    startBtn.addEventListener('click', async () => {
      if (startBtn.disabled) return;
      filterStep.hidden = true;
      cardsStep.hidden = false;
      filtersLink.hidden = false;
      await loadQueue();
      if (queue.length === 0) {
        showEmptyState();
      } else {
        renderNextCard();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
